module.exports = __webpack_public_path__ + "img/doc-pdf.170dfe8c.svg";